// Проверка сессии на бэке (AuthenticateByCookie) выполняется один раз за
// загрузку страницы (issue/11055): требование задачи — при каждом открытии CRM
// проверять пользователя на бэке, но не ходить в сеть на каждой навигации
// внутри уже открытого приложения. Флаг живёт в памяти модуля, поэтому сам
// сбрасывается при перезагрузке страницы и при открытии новой вкладки.
let isRevalidated = false;

export const isSessionRevalidated = (): boolean => isRevalidated;

export const markSessionRevalidated = (): void => {
  isRevalidated = true;
};
